import { addToolsBox, getAllToolsBox, updateToolsBox, deleteToolBox } from '../../api'
export default ({
    state: {
        allToolsBoxList: []
    },
    mutations: {
        SET_TOOLBOX_LIST(state, data) {
            state.allToolsBoxList = data
        }
    },
    actions: {
        async addToolsBox({ state, commit }, { title, content }) {

            const id = await addToolsBox(title, content)
            const list = state.allToolsBoxList = [
                ...state.allToolsBoxList, { title, content, ownId: id }
            ]

            commit('SET_TOOLBOX_LIST', list)
            alert('Toolbox créé')
        },
        async updateToolsBox({ state, commit }, { ownId, data }) {
            await updateToolsBox(data, ownId)
            alert('Toolbox mis a jour')
            const i = state.allToolsBoxList.findIndex(data => data.ownId === ownId)
            const list = state.allToolsBoxList = [
                ...state.allToolsBoxList.slice(0, i),
                { ...data, ownId },
                ...state.allToolsBoxList.slice(i + 1),
            ]
            commit('SET_TOOLBOX_LIST', list)
        },
        async getAllToolsBox({ commit }) {

            const result = await getAllToolsBox()
            commit('SET_TOOLBOX_LIST', result)
        },
        async deleteToolsBox({ state, commit }, id) {
            await deleteToolBox(id)
            const i = state.allToolsBoxList.findIndex(data => data.ownId === id)
            const list = [
                ...state.allToolsBoxList.slice(0, i),
                ...state.allToolsBoxList.slice(i + 1)
            ]
            commit('SET_TOOLBOX_LIST', list)
        }
    },
    getters: {
        getAllToolsBoxList: state => state.allToolsBoxList
    }
})